import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function EventIcon(props: IconProps) {
    return <Icon {...props} iconKey={"event"}/>
}
